import type { ThemeMode } from '@/hooks/useLightMode'

import { Box as ChakraBox } from '@chakra-ui/react'

import { DarkProvider, Flex } from '@hivewatch/dark'

import { EditModeFrame } from '@/components/layouts/EditMode'

import {
  RULES_LEGACY_HEADER_HEIGHT,
  RULES_TABLE_VIEW_PADDING_X,
  RULES_TABLE_VIEW_PADDING_Y,
} from '../constants/layout'
import type { RuleSortColumn, RuleSortOrder } from '../types/rulesTable'
import { getRulesTableToken } from '../utils/theme'
import type { RulesListType } from '../utils/utils'
import { DarkRulesSearchFilterHeader } from './DarkRulesSearchFilterHeader'
import { DarkRulesTable } from './DarkRulesTable'

interface DarkRulesTableViewIProps {
  colorScheme: ThemeMode
  headerHeight?: string
  isLoading?: boolean
  nameFilter: string
  pageIndex: number
  pageSize: number
  rules: RulesListType
  sortColumn: RuleSortColumn | null
  sortOrder: RuleSortOrder | null
  totalCount?: number
  setNameFilter: (value: string) => void
  onPageChange: (pageIndex: number) => void
  onPageSizeChange: (pageSize: number) => void
  onSortChange: (column: RuleSortColumn, order: RuleSortOrder) => void
}

export const DarkRulesTableView = ({
  colorScheme,
  headerHeight = RULES_LEGACY_HEADER_HEIGHT,
  isLoading = false,
  nameFilter,
  pageIndex,
  pageSize,
  rules,
  sortColumn,
  sortOrder,
  totalCount,
  setNameFilter,
  onPageChange,
  onPageSizeChange,
  onSortChange,
}: DarkRulesTableViewIProps) => (
  <DarkProvider>
    <ChakraBox
      h={`calc(100vh - ${headerHeight})`}
      mx='auto'
      pos='relative'
      w='full'
    >
      <EditModeFrame />
      <Flex
        bg={getRulesTableToken(colorScheme, 'bg.app')}
        direction='column'
        gap='0'
        h='100%'
        px={RULES_TABLE_VIEW_PADDING_X}
      >
        <DarkRulesSearchFilterHeader
          colorScheme={colorScheme}
          filter={nameFilter}
          setFilter={setNameFilter}
        />
        <ChakraBox
          flex='1'
          minH={0}
          overflow='hidden'
          py={RULES_TABLE_VIEW_PADDING_Y}
          w='100%'
        >
          <DarkRulesTable
            colorScheme={colorScheme}
            isLoading={isLoading}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
            onSortChange={onSortChange}
            pageIndex={pageIndex}
            pageSize={pageSize}
            rules={rules}
            sortColumn={sortColumn}
            sortOrder={sortOrder}
            totalCount={totalCount}
          />
        </ChakraBox>
      </Flex>
    </ChakraBox>
  </DarkProvider>
)
